import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'Actions/router';
import * as iconStyles from '../../styles/icons.css';
import * as buttonStyles from '../../styles/buttons.css';
import * as styles from './tableCellCharacteristic.css';

// This doesn't use a stateful but ag-grid requires it :(
// eslint-disable-next-line react/prefer-stateless-function
class TableCellCharacteristic extends Component {
  render() {
    const {
      value,
      locked = false,
      context: { store }, // I hate EVERYTHING about this, but I have to pass a class to ag-grid :(
      data: { indicator, characteristic: distribution, count, sortId },
    } = this.props;
    const { dispatch } = store();
    const onClick = () => {
      // Distinguish between multi category indicators, if they exist.
      const id = sortId.fullId ? sortId.fullId : indicator;
      dispatch(push({ [id]: { distribution } }));
    };

    return (
      <div className={styles.cell}>
        <div className={styles.value}>{value}</div>
        {!locked && 1 < count && (
          <button
            className={[styles.button, buttonStyles.closeDark].join(' ')}
            onClick={onClick}
          >
            <i className={iconStyles.iconClose} />
          </button>
        )}
      </div>
    );
  }
}

TableCellCharacteristic.defaultProps = {
  locked: false,
};

TableCellCharacteristic.propTypes = {
  value: PropTypes.string.isRequired,
  locked: PropTypes.bool,
  // onClick: PropTypes.func.isRequired,
  context: PropTypes.shape({
    store: PropTypes.func.isRequired,
  }).isRequired,
  data: PropTypes.shape({
    count: PropTypes.number.isRequired,
    indicator: PropTypes.string.isRequired,
    characteristic: PropTypes.string.isRequired,
  }).isRequired,
};

export default TableCellCharacteristic;

export { TableCellCharacteristic };



// WEBPACK FOOTER //
// ./app/components/tableCellCharacteristic/index.js